import { DeviceRow } from 'components/tables/data/device/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the floor.
 */
export default function FloorColumn({ data: { floor } }: { data: DeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {floor}
    </P2Regular>
  );
}
